module.exports = __webpack_public_path__ + "img/close.667a411c.png";